import { Dispatch, SetStateAction } from "react";
import DateFilter from "./DateFilter";
import EventTypeFilter from "./EventTypeFilter";
import SideFilter from "./SideFilter";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@ac-expo/ui-components";
import { FunnelIcon, TrashIcon } from "../../icons";
import filterStore from "../../services/FilterStore";
import { SearchRadiusFilter } from "./SearchRadiusFilter";

type Data = "events" | "places" | "all";

interface FilterBarMobileProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
  setRadius: (radius: number) => void;
  radius: number;
  reset?: () => void;
}

export function FilterBarMobile({
  startDate,
  endDate,
  setRadius,
  radius,
  reset,
}: FilterBarMobileProps) {
  return (
    <div className="flex w-full items-center justify-between">
      <h1 className="flex w-1/2 grow text-xl font-bold">Découvrir</h1>
      <div className="flex gap-2">
        {/* <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="flex items-center rounded-full bg-white px-2 text-sm font-normal text-gray-500"
            >
              <CaretDownIcon height={16} width={16} fill={"#344054"} />
              Trier par
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-96 p-4">
            <div className="grid gap-4">
              <div className="grid grid-cols-2 gap-4">
                <Button
                  variant={activeData === "all" ? "blue" : "outline"}
                  onClick={() => {
                    setActiveData("all");
                    onDataChange("all");
                  }}
                >
                  Tout voir
                </Button>
                <Button
                  variant={activeData === "events" ? "blue" : "outline"}
                  onClick={() => {
                    setActiveData("events");
                    onDataChange("events");
                  }}
                >
                  Événements
                </Button>
                <Button
                  variant={activeData === "places" ? "blue" : "outline"}
                  onClick={() => {
                    setActiveData("places");
                    onDataChange("places");
                  }}
                >
                  Lieux touristiques
                </Button>
              </div>
            </div>
          </PopoverContent>
        </Popover> */}
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="flex items-center gap-1 rounded-full bg-white px-2 text-sm font-semibold text-gray-500"
            >
              <FunnelIcon height={16} width={16} fill={"#344054"} />
              Filtres
            </Button>
          </PopoverTrigger>
          <PopoverContent className="flex flex-col gap-2">
            <DateFilter startDate={startDate} endDate={endDate} />
            <SearchRadiusFilter
              setRadius={setRadius}
              radius={radius}
              setLocationText={filterStore.setLocationText}
            />
            <EventTypeFilter />
            <SideFilter />
          </PopoverContent>
          {reset !== undefined && (
            <div className="flex items-center">
              <Button
                className="h-[31px] w-full justify-between bg-white font-normal text-gray-500"
                onClick={reset}
              >
                <TrashIcon width={18} height={18} fill={"red"} />
              </Button>
            </div>
          )}
        </Popover>
      </div>
    </div>
  );
}

export default FilterBarMobile;
